import { StageDefinition } from './StageDefinition';

export const stage09: StageDefinition = {
    platforms: [
        [161.05263157894734, 1],
        [114.54545454545458, 2],
        [21.6, 3],
        [28.8, 3],
        [36, 3],
        [43.2, 3],
        [50.400000000000006, 3],
        [57.60000000000001, 3],
        [64.80000000000001, 3],
        [72.00000000000001, 3],
        [79.20000000000002, 3],
        [86.40000000000002, 3],
        [93.60000000000002, 3],
        [100.80000000000003, 3],
        [108.00000000000003, 3],
        [115.20000000000003, 3],
        [144, 3],
        [151.2, 3],
        [158.39999999999998, 3],
        [165.59999999999997, 3],
        [172.79999999999995, 3],
        [179.99999999999994, 3],
        [187.19999999999993, 3],
        [194.39999999999992, 3],
        [201.5999999999999, 3],
        [208.7999999999999, 3],
        [215.9999999999999, 3],
        [223.19999999999987, 3],
        [230.39999999999986, 3],
        [237.59999999999985, 3],
        [244.79999999999984, 3],
        [280.7999999999998, 3],
        [287.9999999999998, 3],
        [295.19999999999976, 3],
        [302.39999999999975, 3],
        [277.89473684210543, 4],
        [274.2857142857144, 5],
        [271.30434782608666, 6],
        [318.260869565217, 6],
        [323.4782608695648, 6],
        [328.6956521739126, 6],
        [333.9130434782604, 6],
        [339.13043478260823, 6],
        [344.34782608695605, 6],
        [349.56521739130386, 6],
        [354.7826086956517, 6],
        [0, 7],
        [4.8, 7],
        [9.6, 7],
        [14.399999999999999, 7],
        [268.8000000000003, 7],
        [267.8048780487801, 8],
        [265.909090909091, 9],
    ],
    traps: [
        [104.51612903225805, 0],
        [174.1935483870968, 0],
        [284.21052631578965, 4],
        [355.2000000000005, 7],
    ],
    stars: [
        [190, 1],
        [88, 1],
        [296, 7],
    ],
};
